import { AfterContentInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SemControlComponent } from '../sem-control/sem-control.component';
import { SemVersionDialogComponent } from 'src/app/components/controls/dialogs/sem-version-dialog/sem-version-dialog.component';
import { SemAuditLogComponent } from '../dialogs/sem-audit-log/sem-audit-log.component';

@Component({
  selector: 'sem-html-js',
  templateUrl: './sem-html-js.component.html',
  styleUrls: ['./sem-html-js.component.css']
})
export class SemHtmlJsComponent extends SemControlComponent implements OnInit, AfterContentInit, OnDestroy {

  @Input() contentbody: string = "";
  innerHtml: string = "";
  @Input() evalAngular: string = "";
  @Input() fieldTitle: string = "";
  sum: number = 0;
  evalFunction: Function | null = null;

  s2: Subscription;

  ngAfterContentInit(): void {
    if (!this.evalAngular || this.evalAngular == "") {
      this.s2 = this.restProviderService.modelValueChanged.subscribe((p_model) => {
        this.model = p_model;
        this.innerHtml = eval("try {function func(p_model,model){ " + this.contentbody + " } func(p_model,this.model);}catch(e){}");
      });
    }
  }

  ngOnDestroy(): void {
    if (this.s2) {
      this.s2.unsubscribe();
    }
  }

  openVersion() {
    this.dialog.open(SemAuditLogComponent, {});
  }

  getAngularEval() {
    try {
      // If evalFunction hasn't been initialized yet
      if (this.evalAngular && this.evalAngular.length > 0) {
        try {
          // Wrap the function definition in parentheses and return it
          this.evalFunction = new Function(`return (${this.evalAngular})`)();
        } catch (e) {
          console.error("Error parsing evalAngular function:", e);
          return;
        }
      }

      //if (!this.evalFunction) return;

      try {
        // Execute the function with the model
        return this.evalFunction(this.model);
      } catch (e) {
        return;
      }

    } catch (e) {
      return;
    }
  }
}
